import { CancelOutlined, Delete, Edit } from '@mui/icons-material'
import { IconButton, TableBody, TableCell, Table, Box, TableHead, TablePagination, TableRow, Typography, Button, Dialog, DialogContent, FormControl, Autocomplete, Stack, TextField, DialogActions } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../global/config/store'
import { ApiCreateRelatedVenues, ApiDeleteRelatedVenues, ApiGetClientEntityByClientGroupId, ApiGetRelatedVenues, ApiGetVenueList, ApiUpdateRelatedVenues } from '../../../apiService/Core/Apicall.tsx'
import useDebounce from '../CreateAllocations/UseDebounce.tsx'
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts'
import { useDispatch } from 'react-redux'
import { ChevronLeftIcon } from 'lucide-react'
import { toast } from 'react-toastify'

function RelatedSites() {
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const [relatedsites, setRelatedSites] = useState<any>([]);
    const [datalength, setdatalength] = useState<any>(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [addNew, setAddNew] = useState<boolean>(false)
    const [venueList, setVenueList] = useState([])
    const [venueList2, setVenueList2] = useState([])
    const [selectedvenue, setSelectedVenue] = useState<any>(null)
    const [selectedvenue2, setSelectedVenue2] = useState<any>(null)
    const [clientEntityList, setClientEntityList] = useState<any>([])
    const [clientEntityId, setClientEntityId] = useState<string | null>(null)
    const [clientEntityId2, setClientEntityId2] = useState<string | null>(null)
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
    const Clientlist = useSelector((state: RootState) => state.client.clientList)
    const debouncedClientEntityId = useDebounce(clientEntityId, 500)
    const debouncedClientEntityId2 = useDebounce(clientEntityId2, 500)
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [venueRelationId, setVenueRelationId] = useState<any>(null)
    const dispatch = useDispatch()


    // ------------------------------------------- Chnage Pagination -----------------------------------------------
    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        if (selectedClient?.clientGroupName) {
            handleGetClientList()
        }
    }, [selectedClient])

    const handleGetClientList = async (clientGroupName?:any) => {
        const data = `?ClientGroupName=${clientGroupName ? clientGroupName : selectedClientName?.clientGroupName}`
        if (!selectedClient?.clientGroupName) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            setClientEntityList(res.data)
            // setClientEntityId(res.data[0].clientEntityId)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }


    useEffect(() => {
        setSelectedClient(selectedClientName)
    }, [selectedClientName])

    const ApiCallGetVenueList = async (debouncedClientEntityId?: any, venueName: string) => {
        let data = `?offset=0&limit=500`
        if (debouncedClientEntityId) {
            data += `&clientEntityId=${debouncedClientEntityId}&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        } else if (selectedClient) {
            data += `&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        }
        const res = await ApiGetVenueList(data)
        const response = res?.data.map((item: any) => ({
            label: item.venueName,
            value: item.venueId,
            state: item.state,
            entityTypeName: item.entityTypeName
        }))
        venueName === "venue1" ? setVenueList(response) : setVenueList2(response)
        // setVenueNameValue(response[0]?.value);
    }
    useEffect(() => {
        if (debouncedClientEntityId || selectedClient) {
            ApiCallGetVenueList(debouncedClientEntityId, "venue1")
        } else {
            setVenueList([])
            setSelectedVenue(null)
        }
    }, [debouncedClientEntityId, selectedClient])


    useEffect(() => {
        if (debouncedClientEntityId2 || selectedClient) {
            ApiCallGetVenueList(debouncedClientEntityId2, "venue2")
        } else {
            setVenueList2([])
            setSelectedVenue2(null)
        }
    }, [debouncedClientEntityId2, selectedClient])

    const handleAddNewSites = async () => {
        if (!selectedvenue || !selectedvenue2) {
            toast.info("Please Select Both Sites")
            return
        }
        if (selectedvenue === selectedvenue2) {
            toast.info("Please Select different Sites")
            return
        }

        try {
            const data = {
                "venueId": selectedvenue,
                "relationVenueId": selectedvenue2

            }
            const res = await ApiCreateRelatedVenues(data)
            if (res?.status) {
                setAddNew(false)
                setSelectedVenue(null)
                setSelectedVenue2(null)
                setClientEntityId(null)
                setClientEntityId2(null)
                getSites()
            }

        } catch (error: any) {
            toast.error(error)
        }
    }

    const handleDeleteRelatedVenues = async (venueRelationId: number) => {
        const confrim = window.confirm("Are you sure you want to delete this related sites ?")
        if (confrim) {
            try {
                const data = `?venueRelationId=${venueRelationId}`
                const res = await ApiDeleteRelatedVenues(data)
                if (res?.status) {
                    getSites()
                }

            } catch (error: any) {
                toast.error(error)
            }
        }
    }
    const handleUpdateNewSites = async () => {
        if (!selectedvenue || !selectedvenue2) {
            toast.info("Please Select Both Sites")
            return
        }
        try {
            const data = {
                "venueRelationId": venueRelationId,
                "venueId": selectedvenue,
                "relationVenueId": selectedvenue2

            }
            const res = await ApiUpdateRelatedVenues(data)
            if (res?.status) {
                setIsEdit(false)
                setVenueRelationId(null)
                setAddNew(false)
                setSelectedVenue(null)
                setSelectedVenue2(null)
                setClientEntityId(null)
                setClientEntityId2(null)
                getSites()
            }

        } catch (error: any) {
            toast.error(error)
        }
    }

    const getSites = async () => {
        try {
            const res = await ApiGetRelatedVenues()
            if (res?.status) {
                setRelatedSites(res?.data)
                setdatalength(res?.count)
            }
        } catch (error: any) {
            toast?.error(error?.message)
        }
    }

    useEffect(() => {
        getSites()
    }, [])

    const handleEditRelation = async(venue: any) => {
        setVenueRelationId(venue?.venueRelationId)
        setSelectedClient(venue?.venueId?.clientEntityId?.clientId?.ClientGroupName)
        setTimeout(async() => {
            await handleGetClientList(venue?.venueId?.clientEntityId?.clientId?.ClientGroupName?.clientGroupName)
        }, 100);
        setIsEdit(true)
        setSelectedVenue(venue?.venueId?.venueId)
        setClientEntityId(venue?.venueId?.clientEntityId?.clientEntityId)
        setSelectedVenue2(venue?.relationVenueId?.venueId)
        setClientEntityId2(venue?.relationVenueId?.clientEntityId?.clientEntityId)
        setAddNew(true)

    }

    console.log("Selected Client", selectedClient)
    const handleClose = () => {
        setIsEdit(false)
        setAddNew(false)
        setVenueRelationId(null)
        setSelectedVenue(null)
        setSelectedVenue2(null)
        setClientEntityId(null)
        setClientEntityId2(null)
    }

    return (
        <div className="w-100 p-2">
            <Box className='bg-light p-3 border-10'>
                <Box className="d-flex mb-5" flexDirection={{xs:"column",sm:"row"}} gap={2} alignItems={'center'}>
                    <Typography flex={1} className="fs-42 text-center">Related Sites</Typography>
                    <Box sx={{ alignItems: 'flex-end', marginRight: 1 }}>
                        <Button
                            variant="contained"
                            onClick={() => { setAddNew(true) }}
                            className="table-row-background py-2"
                        >
                            Add new Sites
                        </Button>
                    </Box>
                </Box>
                <Box className='w-100' overflow={'auto'}>
                    <Table>
                        <TableHead>
                            <TableRow className="table-row-background">
                                {[
                                    "Site-1",
                                    "Entity Name",
                                    "",
                                    "",
                                    "Site-2",
                                    "Entity Name",
                                    "",
                                ].map((item, index) => (
                                    <TableCell key={index} style={{ color: "#fff" }}>
                                        {item}
                                    </TableCell>
                                ))}
                                {/* <TableCell></TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {relatedsites?.map((venue: any) => {

                                return (
                                    <TableRow>
                                        <TableCell>{venue?.venueId?.venueName}</TableCell>
                                        <TableCell>{venue?.venueId?.clientEntityId?.entityName}</TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell>{venue?.relationVenueId?.venueName}</TableCell>
                                        <TableCell>{venue?.relationVenueId?.clientEntityId?.entityName}</TableCell>
                                        <TableCell>
                                            <IconButton onClick={() => { handleEditRelation(venue) }}><Edit /></IconButton>
                                            <IconButton onClick={() => { handleDeleteRelatedVenues(venue?.venueRelationId) }}><Delete /></IconButton>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
            {/* <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={datalength}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}


            <Dialog open={addNew}>
                <DialogContent className="p-4" sx={{ paddingTop: '10px !important' }}>
                    <Box className='d-flex justify-content-end m-0 p-0'><IconButton className="ml-auto" onClick={handleClose}><CancelOutlined></CancelOutlined></IconButton></Box>
                    <Typography className="mb-3 text-center" mx={{xs:0,md:5}} variant="h4" fontWeight={'600'}> {isEdit ? "Update" : "Create"} new related sites</Typography>
                    <Stack className='w-100 mb-3 mt-4'>
                        <FormControl size="small" fullWidth>
                            <Autocomplete
                                // disablePortal
                                id="mm-autocomplete"
                                options={Clientlist}
                                value={selectedClient}
                                getOptionLabel={(option: any) => option?.clientGroupName}
                                isOptionEqualToValue={(option: any, value: any) =>
                                    option.clientGroupDBName === value.clientGroupDBName
                                }
                                onChange={(event, newValue: any) => {
                                    // setSelectedClient(newValue)
                                    dispatch(setSelectedClientGroup(newValue))
                                    // if (!newValue || (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)) {
                                    setClientEntityId(null)
                                    setClientEntityId2(null)
                                    setSelectedVenue(null)
                                    setSelectedVenue2(null)
                                    setClientEntityList([])
                                    // }
                                }}
                                defaultValue="mmcommon"
                                renderInput={(params) => <TextField {...params} label="Select Client" />}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                    <Box className='d-flex flex-column' gap={1}>
                        <Typography gutterBottom>Site-1</Typography>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: 'center',
                                gap: 2,
                                flexWrap: "wrap",
                                flexDirection: 'column'
                            }}
                        >

                            <Stack className='w-100'>
                                <FormControl size="small" fullWidth>
                                    <Autocomplete
                                        // disablePortal
                                        id="beacon-autocomplete"
                                        options={clientEntityList?.filter((item: any) => item.clientEntityId !== null)}
                                        getOptionLabel={(option) => option?.entityName || ""}
                                        onChange={(event, newValue: any) => {
                                            setClientEntityId(newValue?.clientEntityId || null)
                                            if (!newValue) {
                                                setSelectedVenue(null)
                                            }
                                        }}
                                        value={clientEntityList?.find((option: any) => option?.clientEntityId === clientEntityId) || null}
                                        renderInput={(params) => <TextField {...params} label="Select Business" />}
                                        size="small"
                                    />
                                </FormControl>

                            </Stack>
                            <Stack className='w-100'>
                                <FormControl size="small">
                                    <Autocomplete
                                        // disablePortal
                                        id="mm-autocomplete"
                                        options={venueList}
                                        getOptionLabel={(option: any) => `${option?.label} (${option?.state}) (${option?.entityTypeName})`}
                                        value={venueList.find((option: any) => option.value === selectedvenue) || null}
                                        onChange={(event, newValue: any) => {
                                            setSelectedVenue(newValue?.value)
                                        }}
                                        defaultValue=""
                                        renderInput={(params) => <TextField {...params} label="Select Site" />}
                                        size="small"
                                    />
                                </FormControl>
                            </Stack>

                        </Box>
                    </Box>
                    <Box className='d-flex flex-column mt-3' gap={1}>
                        <Typography gutterBottom>Site-2</Typography>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: 'center',
                                gap: 2,
                                flexWrap: "wrap",
                                flexDirection: 'column'
                            }}
                        >

                            <Stack className='w-100'>
                                <FormControl size="small" fullWidth>
                                    <Autocomplete
                                        // disablePortal
                                        id="beacon-autocomplete"
                                        options={clientEntityList?.filter((item: any) => item.clientEntityId !== null)}
                                        getOptionLabel={(option) => option?.entityName || ""}
                                        onChange={(event, newValue: any) => {
                                            setClientEntityId2(newValue?.clientEntityId || null)
                                            if (!newValue) {
                                                setSelectedVenue2(null)
                                            }
                                        }}
                                        value={clientEntityList?.find((option: any) => option?.clientEntityId === clientEntityId2) || null}
                                        renderInput={(params) => <TextField {...params} label="Select Business" />}
                                        size="small"
                                    />
                                </FormControl>

                            </Stack>
                            <Stack className='w-100'>
                                <FormControl size="small">
                                    <Autocomplete
                                        // disablePortal
                                        id="mm-autocomplete"
                                        options={venueList2}
                                        getOptionLabel={(option: any) => `${option?.label} (${option?.state}) (${option?.entityTypeName})`}
                                        value={venueList2.find((option: any) => option.value === selectedvenue2) || null}
                                        onChange={(event, newValue: any) => {
                                            setSelectedVenue2(newValue?.value)
                                        }}
                                        defaultValue=""
                                        renderInput={(params) => <TextField {...params} label="Select Site" />}
                                        size="small"
                                    />
                                </FormControl>
                            </Stack>

                        </Box>
                    </Box>

                </DialogContent>
                <DialogActions>
                    <Button className="table-row-background py-2 text-white px-3 mx-auto mb-2" onClick={() => { isEdit ? handleUpdateNewSites() : handleAddNewSites() }}> {isEdit ? "Update" : "Submit"}</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default RelatedSites
